// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CameraDropZone – estados visuales para grilla de grabaciones */

.camera-drop-zone {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #0a0a0a;
  border: 1px dashed #374151;
  border-radius: 6px;
  overflow: hidden;
}

.camera-drop-zone--drop-target {
  border-color: #a61b34;
  background: rgba(166, 27, 52, 0.08);
}

.camera-drop-zone--idle {
  align-items: center;
  justify-content: center;
}

.camera-drop-zone--preparing {
  position: relative;
  align-items: stretch;
  justify-content: stretch;
  padding: 0;
}

.camera-drop-zone--error {
  align-items: center;
  justify-content: center;
  padding: 12px;
}

.camera-drop-zone--ready {
  border-style: solid;
  border-color: transparent;
}

.camera-drop-zone__video-area {
  position: relative;
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/*
 * Host inline en el tile del grid que recibe el \`<video>\` portaled cuando NO está maximizado.
 * Permanece siempre montado para que el portal tenga un destino DOM estable durante la transición
 * grid ↔ modal y el \`<video>\` no se desmonte (preservando buffer Hls.js).
 */
.camera-drop-zone__inline-player-host {
  position: relative;
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* Overlay de carga en el host inline: cubre el slot mientras el portal del <video> no está conectado al DOM. */
.camera-drop-zone__inline-loading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #111;
  z-index: 5;
  pointer-events: none;
}

/*
 * Stable host (creado vía document.createElement, fuera de React) en el que vive el portal del \`<video>\`.
 * Lo reparentamos por DOM entre \`.camera-drop-zone__inline-player-host\` y \`.video-expand-player\` para
 * preservar Hls.js / currentTime al maximizar/minimizar (el containerInfo del portal no cambia).
 */
.camera-drop-zone__stable-host {
  position: relative;
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.camera-drop-zone__stable-host > .camera-drop-zone__video-area {
  flex: 1 1;
  min-height: 0;
}

/* En vista ampliada, el video-area portaled rellena el contenedor del modal (.video-expand-player). */
.camera-drop-zone__video-area[data-expanded] {
  position: absolute;
  inset: 0;
  flex: initial;
  width: 100%;
  height: 100%;
}

/* Franja de evidencias por cámara (grabaciones) */
.camera-drop-zone__evidence-strip {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 5px 6px 6px;
  background: rgba(12, 12, 12, 0.98);
  border-top: 1px solid #374151;
}

.camera-drop-zone__evidence-strip--overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 6;
  border-top: 1px solid #4b5563;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.45);
}

.camera-drop-zone__evidence-strip-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 1px;
}

.camera-drop-zone__evidence-strip-title {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #9ca3af;
}

.camera-drop-zone__evidence-strip-count {
  font-size: 11px;
  font-weight: 700;
  color: #e5e7eb;
  background: rgba(166, 27, 52, 0.35);
  border: 1px solid rgba(166, 27, 52, 0.5);
  padding: 1px 7px;
  border-radius: 999px;
}

.camera-drop-zone__evidence-scroll {
  display: flex;
  flex-direction: row;
  gap: 6px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 2px;
  min-height: 38px;
  -webkit-overflow-scrolling: touch;
}

.camera-drop-zone__evidence-thumb-wrap {
  position: relative;
  flex-shrink: 0;
  width: 52px;
  height: 36px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #4b5563;
}

.camera-drop-zone__evidence-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.camera-drop-zone__evidence-remove {
  position: absolute;
  top: 1px;
  right: 1px;
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.camera-drop-zone__evidence-remove:hover {
  background: #a61b34;
}

.camera-drop-zone__empty {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  background: #111;
}

.camera-drop-zone__icon {
  width: 48px;
  height: 48px;
  color: #4b5563;
}

.camera-drop-zone__icon svg {
  width: 100%;
  height: 100%;
}

.camera-drop-zone__text {
  font-size: 13px;
  color: #9ca3af;
}

.camera-drop-zone__number {
  font-size: 11px;
  color: #6b7280;
}

.camera-drop-zone__content {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* Ocupa todo el slot y centra logo + anillo XTAM en el medio */
.camera-drop-zone--preparing .camera-drop-zone__content {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 16px 12px;
  box-sizing: border-box;
  gap: 12px;
}

/* Spinner XTAM: un poco más visible dentro de la celda */
.camera-drop-zone__xtam-spinner-wrap {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.camera-drop-zone__xtam-spinner-wrap .xtam-spinner--small {
  padding: 0 8px 4px;
  gap: 10px;
}

.camera-drop-zone__xtam-spinner-wrap .xtam-spinner--small .xtam-spinner__ring {
  width: 56px;
  height: 56px;
}

.camera-drop-zone__xtam-spinner-wrap .xtam-spinner--small .xtam-spinner__ring-segment {
  border-width: 3px;
}

.camera-drop-zone__xtam-spinner-wrap .xtam-spinner--small .xtam-spinner__logo-wrapper {
  width: 30px;
  height: 30px;
}

.camera-drop-zone--preparing .camera-drop-zone__remove {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 4;
}

.camera-drop-zone--preparing .camera-drop-zone__info {
  max-width: 100%;
}

.camera-drop-zone__status {
  font-size: 12px;
  color: #9ca3af;
  margin-bottom: 8px;
}

.camera-drop-zone__error-icon {
  font-size: 32px;
  color: #f59e0b;
  margin-bottom: 8px;
}

.camera-drop-zone__error-message {
  font-size: 12px;
  color: #fca5a5;
  text-align: center;
  margin-bottom: 8px;
}

.camera-drop-zone__retry {
  margin-top: 8px;
  padding: 6px 12px;
  font-size: 12px;
  background: #374151;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.camera-drop-zone__retry:hover {
  background: #4b5563;
}

.camera-drop-zone__overlay-top {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 8px;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.65) 0%, transparent 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  pointer-events: none;
}

.camera-drop-zone__camera-label {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #fff;
  font-weight: 600;
  font-size: 12px;
}

.camera-drop-zone__ping {
  pointer-events: auto;
  flex-shrink: 0;
  padding: 2px 3px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.35);
}

.camera-drop-zone__ping--prep {
  margin-left: 4px;
}

.camera-drop-zone__name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.camera-drop-zone__overlay-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  pointer-events: auto;
}

.camera-drop-zone__evidence-capture {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  cursor: pointer;
}

.camera-drop-zone__evidence-capture-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  border-radius: 999px;
  background: #a61b34;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.35);
  box-sizing: border-box;
}

.camera-drop-zone__evidence-capture:hover {
  background: rgba(166, 27, 52, 0.45);
  border-color: #a61b34;
}

.camera-drop-zone__evidence-capture--captured {
  background: rgba(34, 197, 94, 0.5) !important;
  border-color: #22c55e !important;
  animation: rx-evidence-capture-pop 0.55s ease;
}

@keyframes rx-evidence-capture-pop {
  0% {
    transform: scale(1);
  }
  35% {
    transform: scale(1.12);
  }
  100% {
    transform: scale(1);
  }
}

.camera-drop-zone__overlay-bottom {
  position: absolute;
  bottom: 10px;
  left: 30px;
  right: auto;
  width: max-content;
  max-width: calc(100% - 40px);
  z-index: 10;
  padding: 8px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.65) 0%, transparent 100%);
  display: flex;
  align-items: center;
  gap: 8px;
  pointer-events: none;
}

.camera-drop-zone__status-pill,
.camera-drop-zone__time-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  background: rgba(0, 0, 0, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: #fff;
}

.camera-drop-zone__status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #9ca3af;
}

.camera-drop-zone__status-pill.playing .camera-drop-zone__status-dot {
  background: #22c55e;
}

.camera-drop-zone__status-pill.loading .camera-drop-zone__status-dot {
  background: #f59e0b;
}

.camera-drop-zone__status-pill.error .camera-drop-zone__status-dot,
.camera-drop-zone__status-pill.offline .camera-drop-zone__status-dot {
  background: #ef4444;
}

.camera-drop-zone__expand {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 12;
  pointer-events: none;
}

.camera-drop-zone__badge {
  position: absolute;
  bottom: 8px;
  left: 8px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 600;
  border-radius: 4px;
  text-transform: uppercase;
}

.camera-drop-zone__badge.pvvc {
  background: rgba(59, 130, 246, 0.9);
  color: #fff;
}

.camera-drop-zone__badge.privado {
  background: rgba(34, 197, 94, 0.9);
  color: #fff;
}

.camera-drop-zone__expand,
.camera-drop-zone__remove {
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  transition: opacity 0.2s;
}

.camera-drop-zone__expand {
  width: 40px;
  height: 40px;
  opacity: 0;
}

.camera-drop-zone--ready:hover .camera-drop-zone__expand,
.camera-drop-zone--ready:focus-within .camera-drop-zone__expand {
  opacity: 0.75;
  pointer-events: auto;
}

.camera-drop-zone__expand svg {
  width: 100%;
  height: 100%;
}

.camera-drop-zone__expand:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.85);
}

.camera-drop-zone__remove {
  position: relative;
  width: 28px;
  height: 28px;
  font-size: 18px;
  line-height: 1;
  pointer-events: auto;
}

.camera-drop-zone__remove:hover {
  opacity: 1 !important;
  background: linear-gradient(135deg, #a61b34 0%, #8b1528 100%);
}

.camera-drop-zone__expanded-placeholder {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  background: #0a0a0a;
  color: #9ca3af;
  font-size: 13px;
}

.camera-drop-zone__expanded-placeholder:hover {
  background: #111111;
  color: #d1d5db;
}

.camera-drop-zone__hint {
  font-size: 11px;
  color: #6b7280;
}

.camera-drop-zone__video-area .video-stream {
  flex: 1 1;
  min-height: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/CameraDropZone.css"],"names":[],"mappings":"AAAA,iEAAiE;;AAEjE;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;;EAIE;AACF;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,+GAA+G;AAC/G;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;;AAEA;;;;EAIE;AACF;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA,sGAAsG;AACtG;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA,kDAAkD;AAClD;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;EACpB,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,UAAU;EACV,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,wCAAwC;EACxC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;AACX;;AAEA,yDAAyD;AACzD;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gFAAgF;EAChF,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2CAA2C;EAC3C,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,6CAA6C;EAC7C,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,6EAA6E;EAC7E,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;AACf","sourcesContent":["/* CameraDropZone – estados visuales para grilla de grabaciones */\n\n.camera-drop-zone {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  background: #0a0a0a;\n  border: 1px dashed #374151;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.camera-drop-zone--drop-target {\n  border-color: #a61b34;\n  background: rgba(166, 27, 52, 0.08);\n}\n\n.camera-drop-zone--idle {\n  align-items: center;\n  justify-content: center;\n}\n\n.camera-drop-zone--preparing {\n  position: relative;\n  align-items: stretch;\n  justify-content: stretch;\n  padding: 0;\n}\n\n.camera-drop-zone--error {\n  align-items: center;\n  justify-content: center;\n  padding: 12px;\n}\n\n.camera-drop-zone--ready {\n  border-style: solid;\n  border-color: transparent;\n}\n\n.camera-drop-zone__video-area {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/*\n * Host inline en el tile del grid que recibe el `<video>` portaled cuando NO está maximizado.\n * Permanece siempre montado para que el portal tenga un destino DOM estable durante la transición\n * grid ↔ modal y el `<video>` no se desmonte (preservando buffer Hls.js).\n */\n.camera-drop-zone__inline-player-host {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Overlay de carga en el host inline: cubre el slot mientras el portal del <video> no está conectado al DOM. */\n.camera-drop-zone__inline-loading {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #111;\n  z-index: 5;\n  pointer-events: none;\n}\n\n/*\n * Stable host (creado vía document.createElement, fuera de React) en el que vive el portal del `<video>`.\n * Lo reparentamos por DOM entre `.camera-drop-zone__inline-player-host` y `.video-expand-player` para\n * preservar Hls.js / currentTime al maximizar/minimizar (el containerInfo del portal no cambia).\n */\n.camera-drop-zone__stable-host {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n}\n\n.camera-drop-zone__stable-host > .camera-drop-zone__video-area {\n  flex: 1;\n  min-height: 0;\n}\n\n/* En vista ampliada, el video-area portaled rellena el contenedor del modal (.video-expand-player). */\n.camera-drop-zone__video-area[data-expanded] {\n  position: absolute;\n  inset: 0;\n  flex: initial;\n  width: 100%;\n  height: 100%;\n}\n\n/* Franja de evidencias por cámara (grabaciones) */\n.camera-drop-zone__evidence-strip {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 5px 6px 6px;\n  background: rgba(12, 12, 12, 0.98);\n  border-top: 1px solid #374151;\n}\n\n.camera-drop-zone__evidence-strip--overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 6;\n  border-top: 1px solid #4b5563;\n  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.45);\n}\n\n.camera-drop-zone__evidence-strip-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 0 1px;\n}\n\n.camera-drop-zone__evidence-strip-title {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #9ca3af;\n}\n\n.camera-drop-zone__evidence-strip-count {\n  font-size: 11px;\n  font-weight: 700;\n  color: #e5e7eb;\n  background: rgba(166, 27, 52, 0.35);\n  border: 1px solid rgba(166, 27, 52, 0.5);\n  padding: 1px 7px;\n  border-radius: 999px;\n}\n\n.camera-drop-zone__evidence-scroll {\n  display: flex;\n  flex-direction: row;\n  gap: 6px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding-bottom: 2px;\n  min-height: 38px;\n  -webkit-overflow-scrolling: touch;\n}\n\n.camera-drop-zone__evidence-thumb-wrap {\n  position: relative;\n  flex-shrink: 0;\n  width: 52px;\n  height: 36px;\n  border-radius: 4px;\n  overflow: hidden;\n  border: 1px solid #4b5563;\n}\n\n.camera-drop-zone__evidence-thumb {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.camera-drop-zone__evidence-remove {\n  position: absolute;\n  top: 1px;\n  right: 1px;\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  border: none;\n  border-radius: 3px;\n  background: rgba(0, 0, 0, 0.8);\n  color: #fff;\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.camera-drop-zone__evidence-remove:hover {\n  background: #a61b34;\n}\n\n.camera-drop-zone__empty {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 16px;\n  background: #111;\n}\n\n.camera-drop-zone__icon {\n  width: 48px;\n  height: 48px;\n  color: #4b5563;\n}\n\n.camera-drop-zone__icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.camera-drop-zone__text {\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n.camera-drop-zone__number {\n  font-size: 11px;\n  color: #6b7280;\n}\n\n.camera-drop-zone__content {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Ocupa todo el slot y centra logo + anillo XTAM en el medio */\n.camera-drop-zone--preparing .camera-drop-zone__content {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 16px 12px;\n  box-sizing: border-box;\n  gap: 12px;\n}\n\n/* Spinner XTAM: un poco más visible dentro de la celda */\n.camera-drop-zone__xtam-spinner-wrap {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.camera-drop-zone__xtam-spinner-wrap .xtam-spinner--small {\n  padding: 0 8px 4px;\n  gap: 10px;\n}\n\n.camera-drop-zone__xtam-spinner-wrap .xtam-spinner--small .xtam-spinner__ring {\n  width: 56px;\n  height: 56px;\n}\n\n.camera-drop-zone__xtam-spinner-wrap .xtam-spinner--small .xtam-spinner__ring-segment {\n  border-width: 3px;\n}\n\n.camera-drop-zone__xtam-spinner-wrap .xtam-spinner--small .xtam-spinner__logo-wrapper {\n  width: 30px;\n  height: 30px;\n}\n\n.camera-drop-zone--preparing .camera-drop-zone__remove {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 4;\n}\n\n.camera-drop-zone--preparing .camera-drop-zone__info {\n  max-width: 100%;\n}\n\n.camera-drop-zone__status {\n  font-size: 12px;\n  color: #9ca3af;\n  margin-bottom: 8px;\n}\n\n.camera-drop-zone__error-icon {\n  font-size: 32px;\n  color: #f59e0b;\n  margin-bottom: 8px;\n}\n\n.camera-drop-zone__error-message {\n  font-size: 12px;\n  color: #fca5a5;\n  text-align: center;\n  margin-bottom: 8px;\n}\n\n.camera-drop-zone__retry {\n  margin-top: 8px;\n  padding: 6px 12px;\n  font-size: 12px;\n  background: #374151;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.camera-drop-zone__retry:hover {\n  background: #4b5563;\n}\n\n.camera-drop-zone__overlay-top {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  padding: 8px;\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.65) 0%, transparent 100%);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  pointer-events: none;\n}\n\n.camera-drop-zone__camera-label {\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #fff;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.camera-drop-zone__ping {\n  pointer-events: auto;\n  flex-shrink: 0;\n  padding: 2px 3px;\n  border-radius: 4px;\n  background: rgba(0, 0, 0, 0.35);\n}\n\n.camera-drop-zone__ping--prep {\n  margin-left: 4px;\n}\n\n.camera-drop-zone__name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.camera-drop-zone__overlay-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  pointer-events: auto;\n}\n\n.camera-drop-zone__evidence-capture {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  border-radius: 6px;\n  background: rgba(0, 0, 0, 0.5);\n  color: #fff;\n  cursor: pointer;\n}\n\n.camera-drop-zone__evidence-capture-badge {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 16px;\n  text-align: center;\n  border-radius: 999px;\n  background: #a61b34;\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  box-sizing: border-box;\n}\n\n.camera-drop-zone__evidence-capture:hover {\n  background: rgba(166, 27, 52, 0.45);\n  border-color: #a61b34;\n}\n\n.camera-drop-zone__evidence-capture--captured {\n  background: rgba(34, 197, 94, 0.5) !important;\n  border-color: #22c55e !important;\n  animation: rx-evidence-capture-pop 0.55s ease;\n}\n\n@keyframes rx-evidence-capture-pop {\n  0% {\n    transform: scale(1);\n  }\n  35% {\n    transform: scale(1.12);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.camera-drop-zone__overlay-bottom {\n  position: absolute;\n  bottom: 10px;\n  left: 30px;\n  right: auto;\n  width: max-content;\n  max-width: calc(100% - 40px);\n  z-index: 10;\n  padding: 8px;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.65) 0%, transparent 100%);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  pointer-events: none;\n}\n\n.camera-drop-zone__status-pill,\n.camera-drop-zone__time-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  background: rgba(0, 0, 0, 0.55);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  color: #fff;\n}\n\n.camera-drop-zone__status-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #9ca3af;\n}\n\n.camera-drop-zone__status-pill.playing .camera-drop-zone__status-dot {\n  background: #22c55e;\n}\n\n.camera-drop-zone__status-pill.loading .camera-drop-zone__status-dot {\n  background: #f59e0b;\n}\n\n.camera-drop-zone__status-pill.error .camera-drop-zone__status-dot,\n.camera-drop-zone__status-pill.offline .camera-drop-zone__status-dot {\n  background: #ef4444;\n}\n\n.camera-drop-zone__expand {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 12;\n  pointer-events: none;\n}\n\n.camera-drop-zone__badge {\n  position: absolute;\n  bottom: 8px;\n  left: 8px;\n  padding: 2px 6px;\n  font-size: 10px;\n  font-weight: 600;\n  border-radius: 4px;\n  text-transform: uppercase;\n}\n\n.camera-drop-zone__badge.pvvc {\n  background: rgba(59, 130, 246, 0.9);\n  color: #fff;\n}\n\n.camera-drop-zone__badge.privado {\n  background: rgba(34, 197, 94, 0.9);\n  color: #fff;\n}\n\n.camera-drop-zone__expand,\n.camera-drop-zone__remove {\n  border: none;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 4px;\n  transition: opacity 0.2s;\n}\n\n.camera-drop-zone__expand {\n  width: 40px;\n  height: 40px;\n  opacity: 0;\n}\n\n.camera-drop-zone--ready:hover .camera-drop-zone__expand,\n.camera-drop-zone--ready:focus-within .camera-drop-zone__expand {\n  opacity: 0.75;\n  pointer-events: auto;\n}\n\n.camera-drop-zone__expand svg {\n  width: 100%;\n  height: 100%;\n}\n\n.camera-drop-zone__expand:hover {\n  opacity: 1;\n  background: rgba(0, 0, 0, 0.85);\n}\n\n.camera-drop-zone__remove {\n  position: relative;\n  width: 28px;\n  height: 28px;\n  font-size: 18px;\n  line-height: 1;\n  pointer-events: auto;\n}\n\n.camera-drop-zone__remove:hover {\n  opacity: 1 !important;\n  background: linear-gradient(135deg, #a61b34 0%, #8b1528 100%);\n}\n\n.camera-drop-zone__expanded-placeholder {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  cursor: pointer;\n  background: #0a0a0a;\n  color: #9ca3af;\n  font-size: 13px;\n}\n\n.camera-drop-zone__expanded-placeholder:hover {\n  background: #111111;\n  color: #d1d5db;\n}\n\n.camera-drop-zone__hint {\n  font-size: 11px;\n  color: #6b7280;\n}\n\n.camera-drop-zone__video-area .video-stream {\n  flex: 1;\n  min-height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
